import { DATAVIEW_BASKET_DEFAULT_SIZE, KpkBasket } from "@keepeek/commons";
import { atom, atomFamily } from "recoil";

export const selectedBasketsWidgetState = atomFamily<KpkBasket["id"][], string>({
  key: "SelectedBasketsWidgetState",
  default: [],
});

export const currentPageBaskets = atom<number>({
  key: "CurrentPageBasketsState",
  default: 1,
});

export const currentSizeBaskets = atom<number>({
  key: "CurrentSizeBasketsState",
  default: DATAVIEW_BASKET_DEFAULT_SIZE,
});
